import React, { useState, useEffect } from "react";
import { Input, Modal } from "antd";
import { CirclePicker } from "react-color";
import { useDispatch, useSelector } from "react-redux";
import Localize from "../Localized/Localize.comp";
import Label from "../Label/Label";
import { createTagApi } from "../../api/tag.api";

const CreateTagModal = ({ visible, setVisible, onCreate }) => {
  const tags = useSelector((state) => state.tag.tagsList);

  const [tagValue, setTagValue] = useState("");
  const [colorValue, setColorValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const clearTagFields = () => {
    setTagValue("");
    setColorValue("");
    setErrorMessage("");
  };
  // Clear fields when modal closes
  useEffect(() => {
    if (!visible) {
      clearTagFields();
    }
  }, [visible]);

  const handleTagChange = (e) => {
    const foundTag = tags.find(
      (tag) => tag.name.toLowerCase() === e.target.value.toLowerCase(),
    );
    if (foundTag) {
      setErrorMessage(Localize("TAG.ERROR_MESSAGE"));
    } else {
      setErrorMessage("");
    }
    setTagValue(e.target.value);
  };

  const handleColorChange = (color) => {
    setColorValue(color);
  };

  const handleCancel = () => {
    clearTagFields();
    setVisible(false);
  };

  const handleOk = async () => {
    await createTagApi({
      name: tagValue,
      color: colorValue.hex.replace("#", "").toUpperCase(),
    });
    clearTagFields();
    setVisible(false);

    // Call the onCreate callback if provided
    if (onCreate) {
      onCreate();
    }
  };

  const isOkDisabled = !tagValue || !colorValue || errorMessage;

  return (
    <Modal
      title={Localize("TAG.ADD_TAG")}
      visible={visible}
      cancelText={Localize("COMMON.CANCEL")}
      okText={Localize("COMMON.CREATE_NEW")}
      onCancel={handleCancel}
      onOk={handleOk}
      okButtonProps={{ disabled: isOkDisabled }}
    >
      <Label value={Localize("TAG.INSERT_NEW_TAG")} />
      <Input value={tagValue} onChange={handleTagChange} />
      <p className="mt-1" style={{ color: "red" }}>
        {errorMessage}
      </p>
      <Label value={Localize("TAG.SELECT_COLOR")} className="mt-3" />
      <CirclePicker color={colorValue} onChange={handleColorChange} />
    </Modal>
  );
};

export default CreateTagModal;
